import { z, registry } from './registry.js';
type AnyObject = Record<string, any>;

type DeepPartialAny<T> = {
  /** Makes each property optional and turns each leaf property into any, allowing for type overrides by narrowing any. */
  [P in keyof T]?: T[P] extends AnyObject ? DeepPartialAny<T[P]> : any;
};

// Fixed version with proper recursion handling
export type Modify<A, B extends DeepPartialAny<A>> = {
  [K in keyof (A & B)]: K extends keyof B
  ? K extends keyof A
  ? A[K] extends AnyObject
  ? B[K] extends AnyObject
  ? Modify<A[K], B[K] & DeepPartialAny<A[K]>>
  : B[K]
  : B[K]
  : B[K]
  : K extends keyof A
  ? A[K]
  : never;
};

export interface Metadata {
  label: string;
  value: string;
  secure?: boolean;
}

// @ts-ignore
export const MetadataItemZod = registry.register("MetadataItem", z.object({
  label: z.string().openapi({ description: 'The label for the metadata item.', example: 'User ID' }),
  value: z.string().openapi({ description: 'The value of the metadata item.', example: 'usr_12345' }),
  secure: z.boolean().optional().openapi({ description: 'Indicates if the metadata value should be treated as secure.', example: false })
}).openapi({ description: "A metadata item." }));